import { render } from "./VitamindPlus.vue?vue&type=template&id=427c2d14&scoped=true"
import script from "./VitamindPlus.vue?vue&type=script&lang=js"
export * from "./VitamindPlus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427c2d14"]])

export default __exports__